import Header from "../../components/Header/Header";
import CompanyBox from "./components/CompanyBox/CompanyBox";
import Hero from "../../components/Hero/Hero";
import Footer from "../../components/Footer/Footer";
import Newsletter from "../../components/Footer/components/Newsletter/Newsletter";
import { CompaniesListing } from "../../../pages/api/company";
import FilterBox from "./components/FilterBox/FilterBox";
import { useState } from "react";
import Pagination from "../../components/Pagination/Pagination";
import { NextSeo } from "next-seo";
import { companiesPerPage } from "../../../common/constants";
import ServerPagination from "../../components/ServerPagination/ServerPagination";

interface KompanijeProps {
    companies: CompaniesListing[];
    page: number;
    total: number;
}

export default function Kompanije({ companies, page, total }: KompanijeProps) {
    const [filteredCompanies, setFilteredCompanies] = useState(companies);
    const [activePage, setActivePage] = useState(1);

    const showingCompanies = filteredCompanies?.slice(
        (activePage - 1) * companiesPerPage,
        companiesPerPage * activePage
    );
    return (
        <div className="relative bg-white">
            <Header />
            <Hero
                title="Istraži Kompanije"
                subtitle="Pogledaj koje kompanije zapošljavaju, pročitaj iskustva
                    drugih o kompanijama i ostavi svoja iskustva."
            />
            <NextSeo
                title="Dzobs.com | IT kompanije | Najveća baza u BiH"
                description="Istraži top IT kompanije u BiH, pregledaj otvorene pozicije i iskustva radnika."
                canonical="https://www.dzobs.com/kompanije"
                openGraph={{
                    images: [
                        {
                            url: "https://www.dzobs.com/social.png",
                        },
                    ],
                }}
            />
            <FilterBox
                setFilteredCompanies={setFilteredCompanies}
                setActivePage={setActivePage}
                companies={companies}
            />
            <div className="relative mb-20 max-w-screen-lg mx-auto px-6 lg:px-0 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {companies.length > 0 &&
                    companies.map((company) => (
                        <CompanyBox key={company.slug} company={company} />
                    ))}
            </div>
            <ServerPagination
                activePage={page}
                perPage={companiesPerPage}
                total={total}
            />
            {!companies?.length && (
                <div className=" mb-32 text-center">
                    Nema rezultata pretrage...
                </div>
            )}
            <Newsletter bg="bg-gray-light" />
            <Footer />
        </div>
    );
}
